import styled from 'styled-components';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';

export const ContainerLoader = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TextAnimation = styled.p`
  font-size: 50px;
  font-weight: bold;
  font-family: 'Cairo', sans-serif;
  padding-left: 50px;
  margin: 0px;
  text-align: left;
  color: white;
`;

export const Container3D = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 800px) {
    flex-direction: row;
  }
`;

export const ContainerHome = styled.button`
  width: 100%;
  height: 100vh;
  position: relative;
  border-width: 0;
  background: #6085fc;
`;

export const ButtonLink = styled.button`
  text-align: center;
  background: white;
  width: 100px;
  padding: 7px;
  margin-right: 26px;
  text-decoration: none;
  color: black;
  font-weight: bold;
  border-radius: 20px;
  border-width: 0;
`;

export const buttonLinkStep = {
  marginRight: 20,
  textDecoration: 'none',
  color: '#6085FC',
  fontWeight: 'bold'
};

export const ContainerMain = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  align-items: center;
  @media (min-width: 800px) {
    flex-direction: row;
  }
`;

export const ContainerInput = styled.div`
  width: 100%;
  padding: 40px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  @media (min-width: 800px) {
    width: 50%;
    height: 100vh;
    padding: 0px;
  }
`;

export const LabelInput = styled.div`
  font-size: 12px;
  width: 98%;
  text-align: center;
  margin: 0px 0px 10px 0px;
  font-weight: bold;
  @media (min-width: 650px) {
    font-size: 22px;
    width: 320px;
  }
`;

export const Error = styled.p`
  margin: 0;
  color: red;
`;

export const ContainerZone = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  @media (min-width: 1250px) {
    flex-direction: row;
  }
`;

export const ItemZone = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  @media (min-width: 768px) {
    width: 200px;
  }
`;

export const ContainerResume = styled.div`
  position: sticker;
  background: #6085fc;
  width: 100%;
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-bottom: 20px;
  @media (min-width: 800px) {
    width: 50%;
    height: 100vh;
    padding-bottom: 0px;
  }
`;

export const Text = styled.p`
  font-size: 15px;
  text-align: center;
  color: black;
  margin: 6px;
  padding: 5px;
  @media (min-width: 1100px) {
    font-size: 19px;
  }
`;

export const Title = styled(Text)`
  font-weight: bold;
  text-align: center;
`;

export const ContainerStepper = styled.div`
  width: 100%;
  margin-bottom: 20px;
  @media (min-width: 600px) {
    padding-top: 30px;
  }
`;

export const ContainerReview = styled.div`
  display: flex;
  width: 100%;

  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const BackgroundImage = styled.div`
  position: relative;
  width: 100%;
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  background-image: ${(props) => `url(${props.img})`};
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  @media (min-width: 800px) {
    width: 50%;
    height: 100vh;
  }
`;

export const BackgroundDepartment = styled.div`
  width: 100%;
  height: 60vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background-image: ${(props) => `url(${props.img})`};
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  @media (min-width: 800px) {
    width: 50%;
    height: 100vh;
  }
`;

export const MarginTop = styled.div`
  margin-top: 20px;
`;

export const styleGlobal = {
  paddingLeft: 10,
  height: 40,
  fontSize: 20,
  width: '80%',
  borderRadius: 4,
  borderColor: 'black'
};

export const styleInput = {
  ...styleGlobal,
  width: '80%'
};

export const styleSelect = {
  ...styleGlobal,
  width: 150
};

export const ButtonsContainer = styled.div`
  position: sticker;
  background: #6085fc;
  width: 100%;
  height: 20vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  padding-bottom: 20px;
  @media (min-width: 800px) {
    width: 40%;
    height: 100vh;
    padding-bottom: 0px;
    padding: 6px;
  }
`;

export const RowFilter = styled(Row)`
  width: 80%;
  margin: 20px auto;
`;

export const ColFilter = styled(Col)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

export const FormSelect = styled(Form.Select)`
  width: 200px;
`;

export const Img = styled.img`
  max-height: 300px;
  width: 70%;
`;

export const ImgResume = styled.img`
  max-height: 200px;
  width: 50%;
`;

export const RowGroupCardNew = styled(Row)`
  flex-wrap: wrap;
  width: 100%;
  @media (min-width: 800px) {
    width: 80%;
  }
  margin: 20px auto !important;
`;

export const RowGroupCard = styled(Row)`
  justify-content: space-around;
  width: 100%;
  @media (min-width: 800px) {
    width: 80%;
  }
  margin: 20px auto !important;
`;
export const ColCardNew = styled(Col)`
box-shadow: 5px 5px 10px #d3d3d3;
  margin-right: 25px;
  margin-bottom:20px;
  @media (min-width: 800px) {
    padding: inherit;
  }
`;

export const ColCard = styled(Col)`
  margin: 10px 1px;

  @media (min-width: 800px) {
    padding: inherit;
  }
`;

export const CardContainerNew = styled(Col)`
  cursor: pointer;
  margin: 0px auto;
  width: 100%;
  justify-content: center;
  display:flex;
  flex-direction: column;
  height:320px; 
`;

export const CardContainer = styled(Col)`
  margin: 0px auto;
  width: 100%;
`;

export const CardImgNew = styled(Card.Img)`
  width: 100px;
  height: 100px;
  border-radius: 100px; 
  margin: 0px auto;
`;

export const CardImg = styled(Card.Img)`
  width: 100%;
  height: 130px;
`;

export const CardBody = styled(Card.Body)`
  height: 30%;
  cursor: pointer;
`;

export const CardTitle = styled(Card.Title)`
  color: #6c757d;
  font-size: 13px;
  text-align: center;
`;

export const CardFooter = styled(Card.Footer)`
  margin: 0px auto;
  padding: 0px;
  font-size: 17px;
  text-align: center;
  font-weight: bold;
`;

export const RowGroupByType = styled(Row)`
  justify-content: space-around;
  width: 100%;
`;

export const ButtonRent = styled(Button)`
  background: #6085fc;
  margin: 10px auto;
  width: 100%;
`;

export const ButtonNotification = styled(Button)`
  background: #6085fc;
  margin: 10px auto;
  width: 50%;
`;

export const ContainerLayout = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ContainerChildren = styled.div`
  width: 100%;
`;

export const ContainerNab = styled.div`
  height: 100vh;
  position: sticky;
  top: 0;
`;

export const TextTile = styled.p`
  font-size: 18px;
  font-weight: bold;
  font-family: 'Cairo', sans-serif;
  padding-left: 50px;
  margin: 0px;
  text-align: left;
  color: #6085fc;
  padding-bottom: 13px;
  padding-top: 13px;
`;

export const TextCatalogo = styled.p`
  height: 70px;
  font-size: 16px;
  font-weight: bold;
  font-family: 'Cairo', sans-serif;
  margin: 0px;
  text-align: center;

  padding-bottom: 13px;
  padding-top: 13px;
  @media (min-width: 800px) {
    font-size: 18px;
  }
`;

export const TextCompany = styled.p`
border: 1px solid green;
  font-size: 25px;
  font-weight: bold;
  font-family: 'Cairo', sans-serif;
  padding-left: 50px;
  margin: 0px;
  text-align: center;
  color: #6085fc;
  padding-bottom: 13px;
  padding-top: 13px;
`;

export const TextParragraf = styled.p`
  font-size: 16px;
  font-family: 'Cairo', sans-serif;
  padding-left: 50px;
  margin: 0px;
  text-align: justify;
`;

export const styleTextArea = {
  height: '40%',
  fontSize: 20,
  width: '90%',
  borderRadius: 1,
  borderColor: 'gray'
};

export const ColNoti = styled(Col)`
  display: flex;
  flex-direction: column !important;
  align-items: center;
  margin-bottom: 10;
  @media (min-width: 800px) {
    flex-direction: row;
  }
`;

export const WeCol = styled(Col)`
  height: 300;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-item: center;
  flex-direction: column;
  padding: 10;
  @media (min-width: 800px) {
    padding: 40;
  }
`;
export const WeColNew = styled(Col)`
  border: 0.1px solid #d3d3d3;
  height: 300;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-item: center;
  flex-direction: column;
  padding: 10;
  @media (min-width: 800px) {
    padding: 40;
  }
`;

export const ImgNew = styled.img`
  width: 80%;
  border-radius: 20px;
  @media (min-width: 800px) {
    width: 200px;
    height: 100px;
  }
`;

export const InfoUser = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 800px) {
    flex-direction: row;
  }
`;
